// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2JseF","rootCenter":"LoadMoreObserver_rootCenter__3z6XB","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2Upzy"};